<template>
  <div class="report">
    <Search v-model="searchField.keyword" @searchBtn="searchBtn">
      <template v-slot:btns>
        <el-button type="primary" plain round @click="addBtn">
          <i class="el-icon-plus el-icon--left"></i> 新建项目
        </el-button>
      </template>
    </Search>

    <TableList
      :table-data="tableData"
      :label-data="tableLabel"
      :loading="loading"
      :page="currentPage"
      :page-total="pageTotal"
      @changePage="changePage"
    >
      <template v-slot:state="{ scope }">
        <el-link :underline="false" disabled>
          {{ scope.row.state_obj.text }}
        </el-link>
      </template>

      <template v-slot:active="{ scope }">
        <el-button
          v-if="scope.row.state == 3"
          type="text"
          @click="recreateReport(scope.row.productId)"
        >
          重新生成
        </el-button>

        <el-button
          v-if="scope.row.report_url"
          class="mr-10"
          type="text"
          @click="$viewReport(scope.row.report_url)"
        >
          查看报告
        </el-button>

        <el-link
          type="danger"
          :underline="false"
          style="vertical-align: initial"
          @click="deleteRow(scope.$index, scope.row.productId, tableData)"
        >
          删除
        </el-link>
      </template>
    </TableList>

    <Dialog
      v-model="dialogVisible"
      title="新建项目"
      width="50%"
      @handleClose="$refs['addForm'].resetFields()"
    >
      <el-form
        class="form-box"
        ref="addForm"
        :model="addForm"
        :rules="addRules"
        hide-required-asterisk
        label-width="80px"
      >
        <el-form-item label="企业名称" prop="company_name">
          <el-input v-model="addForm.company_name" placeholder="请输入公司名称"></el-input>
        </el-form-item>
        <el-form-item label="专利质押">
          <el-row type="flex" :gutter="10">
            <el-col :span="15">
              <el-form-item prop="zltype">
                <el-select v-model="addForm.zltype" multiple placeholder="专利类型（可多选）">
                  <el-option label="发明专利" value="1"></el-option>
                  <el-option label="实用新型" value="2"></el-option>
                  <el-option label="外观设计" value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item prop="zlyear">
                <el-select v-model="addForm.zlyear" placeholder="专利剩余年限">
                  <el-option
                    v-for="item in 19"
                    :key="item"
                    :label="'≥' + item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>

        <div class="form-btns">
          <el-button type="primary" :loading="addLoading" @click="addSubmit('addForm')">
            申请尽调报告
          </el-button>
        </div>

        <p class="form-remark">
          <span>*</span>
          &nbsp;每天最多可以申请
          <span>{{ user_info.power.ProductAll }}</span>
          个报告 &nbsp;|&nbsp; 您今天还可申请 {{ user_info.power.ProductNum }} 个报告
        </p>
      </el-form>
    </Dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as reportApi from "@/api/report.js";
import Search from "@/components/Search";
import TableList from "@/components/TableList";
import Dialog from "@/components/Dialog";
export default {
  name: "Report",
  components: {
    Search,
    TableList,
    Dialog
  },
  data() {
    return {
      // 搜索字段
      searchField: {
        keyword: ""
      },

      tableData: [],
      tableLabel: [
        { label: "立项时间", value: "created_at" },
        { label: "公司名称", value: "company_name" },
        { label: "报告状态", value: "state", isSlot: true },
        { label: "操作", value: "active", isSlot: true }
      ],
      currentPage: 1,
      pageTotal: null,
      loading: false,

      addForm: {
        company_name: "",
        zltype: [],
        zlyear: ""
      },
      addRules: {
        company_name: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        zltype: [{ required: true, message: "请选择专利类型", trigger: "change" }],
        zlyear: [{ required: true, message: "请选择专利剩余年限", trigger: "change" }]
      },
      dialogVisible: false,
      addLoading: false,

      timer: null, // 定时器
      count: 10 // 倒计时
    };
  },
  computed: {
    ...mapGetters(["user_info"])
  },
  mounted() {
    this.getReportList();
  },
  methods: {
    ...mapActions("user", ["getUserPowerFun"]),

    // 判断报告状态
    isReportStatus(state) {
      let results = {};
      switch (state) {
        case 1:
          results = { isClick: false, text: "生成中···" };
          break;
        case 2:
          results = { isClick: false, text: "生成成功" };
          break;
        case 3:
          results = { isClick: false, text: "生成失败" };
          break;
        default:
          results;
          break;
      }
      return results;
    },

    // 获取数据列表
    async getReportList(page = 1) {
      // this.loading = true;
      this.stopTimeFn();
      try {
        let { data } = await reportApi.getReportList({ page, ...this.searchField });
        this.tableData = data.data.map(v => {
          v["state_obj"] = this.isReportStatus(v.state);

          return v;
        });
        this.currentPage = page;
        this.pageTotal = data.total;
        this.count = 10;
        this.meterTimeFn();
      } catch (error) {}
      // this.loading = false;
    },

    // 打开新建弹框
    addBtn() {
      this.getUserPowerFun();
      this.dialogVisible = true;
    },

    // 创建项目
    async addSubmit(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.addLoading = true;
          try {
            const data = await reportApi.addReport(this.addForm);
            this.dialogVisible = false;
            this.$refs[formName].resetFields();
            this.getReportList();
          } catch {}
          this.addLoading = false;
        } else {
          return false;
        }
      });
    },

    // 删除项目
    deleteRow(ind, id, rows) {
      this.$confirm("是否确定删除该项目，删除后不可恢复！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false
      })
        .then(async () => {
          try {
            await reportApi.delReport(id);
            rows.splice(ind, 1);
            this.$message.success("删除成功!");
          } catch (error) {
            return false;
          }
        })
        .catch(() => {});
    },

    // 重新生成报告
    async recreateReport(productId) {
      try {
        await reportApi.recreateReport(productId);
      } catch (error) {}
    },

    // 搜索
    async searchBtn() {
      this.getReportList(1);
    },
    // 分页
    async changePage(page) {
      this.getReportList(page);
    },

    // 循环请求接口
    meterTimeFn() {
      this.timer = setInterval(async () => {
        if (this.count > 0 && this.count <= 10) {
          this.count--;
        } else if (this.count === 0) {
          this.getReportList(this.currentPage); // 请求数据
          this.stopTimeFn();
        }
      }, 1000);
    },
    // 停止循环请求接口
    stopTimeFn() {
      clearInterval(this.timer);
      this.timer = null;
    }
  },

  deactivated() {
    this.stopTimeFn();
  }
};
</script>

<style scoped lang="less"></style>
